import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-input-fomrly-field',
  template: `
    <input [type]="to.type"
      [formControl]="formControl"
      [formlyAttributes]="field"
      class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
      >
  `,
  styles: [  ]
})
export class InputFormlyFieldComponent extends FieldType<FieldTypeConfig> {}

